import { useLayoutEffect, useRef, type RefObject } from 'react';

function getRevealScrollOffset(journeyPanel: HTMLElement, mapSection: HTMLElement): number {
  const stickyOffsetPx = Number.parseFloat(getComputedStyle(mapSection).scrollMarginTop) || 0;
  const roomAboveMapPx = mapSection.getBoundingClientRect().top - stickyOffsetPx;
  if (roomAboveMapPx < 0) return roomAboveMapPx;

  const hiddenBelowPx = journeyPanel.getBoundingClientRect().bottom - window.innerHeight;
  if (hiddenBelowPx <= 0) return 0;
  return Math.min(hiddenBelowPx, roomAboveMapPx);
}

export function useRevealMapAndJourneyPanel(
  journeyPanelRef: RefObject<HTMLElement | null>,
  mapSectionRef: RefObject<HTMLElement | null>,
  revealKey: string | null,
) {
  const previousRevealKeyRef = useRef<string | null>(null);

  useLayoutEffect(() => {
    const wasJourneyOpen = previousRevealKeyRef.current !== null;
    previousRevealKeyRef.current = revealKey;
    if (revealKey === null || wasJourneyOpen) return;

    const journeyPanel = journeyPanelRef.current;
    const mapSection = mapSectionRef.current;
    if (!journeyPanel || !mapSection) return;

    const scrollOffsetPx = getRevealScrollOffset(journeyPanel, mapSection);
    if (scrollOffsetPx !== 0) window.scrollBy({ top: scrollOffsetPx, behavior: 'instant' });
  }, [journeyPanelRef, mapSectionRef, revealKey]);
}
